/**
 * `47` — *{Every time period, schedulerConfig}*. Board-level: the event it matches carries no
 * `item_id`, so the actions downstream operate on the board (create an item, duplicate a group).
 *
 * `occurrences` is the interval multiplier ("every N weeks"), Sunday is weekday `7`, and `hour`
 * is a **UTC** hour with quarter-hour precision — all three measured on the sandbox
 * (`discovery/automations/sandbox-experiments.md` E1–E3).
 */
import { z } from 'zod';
import { defineTrigger } from '../block.js';
import { AUTOMATION_SCHEDULE_DUE } from '../events.js';
import { schedulerConfigSchema } from '../values.js';
export const everyTimePeriodParams = z.object({ schedulerConfig: schedulerConfigSchema });
export const everyTimePeriodTrigger = defineTrigger({
    id: '47',
    kind: 'trigger',
    app: 'monday',
    sentencePartial: '{Every time period, schedulerConfig}',
    paramsSchema: everyTimePeriodParams,
    subscribes: [AUTOMATION_SCHEDULE_DUE],
    timeBased: true,
    references: () => [],
    matches: () => true,
    outputs(event) {
        return { boardId: event.boardId, itemId: null, dueAt: event.payload.dueAt };
    },
});
//# sourceMappingURL=47.js.map